import React from 'react'
import Moment from 'react-moment'
import 'moment/locale/es';
import getSymbolFromCurrency from "currency-symbol-map"
import { Tag } from 'rsuite';
import { Link } from 'react-router-dom'

export const getColumns = (userSetting, isActives, t) => {
    return [
        {
            name: "Id",
            selector: "idOriginTransaction",
            sortable: false,
            width: "150px",
            center: true,
            cell: (row) => (
                <Link
                    className="btn_link fw-700"
                    to={`/subscriptions-details/${row.status}/${row.idSubscription}`}
                >
                    {row.idOriginTransaction}
                </Link>
            ),
        },
        {
            name: t('subscription.templateColumns.reference'),
            selector: "referenceNumber",
            sortable: false,
            cell: (row) => (
                <Link
                    className="btn_link fw-700"
                    to={`/subscriptions-details/${row.status}/${row.idSubscription}`}
                >
                    {row.referenceNumber}
                </Link>
            ),
        },
        {
            name: isActives ? t('subscription.templateColumns.createDate') : t('subscription.templateColumns.cancellationDate'),
            selector: "date",
            sortable: false,
            format: (row) => (
                <Moment locale="es" format="DD/MM/YYYY hh:mm:ss A">
                    {row.active ? row.date : row.modificationDate}
                </Moment>
            ),
        },
        {
            name: t('subscription.templateColumns.frequency'),
            selector: "frequency",
            sortable: false,
            cell: (row) => (
                <span>
                    {
                        {
                            Daily: t('subscription.templateColumns.daily'),
                            Biweekly: t('subscription.templateColumns.biweekly'),
                            Monthly: t('subscription.templateColumns.monthly'),
                            Halfyearly: t('subscription.templateColumns.halfyearly'),
                            Annual: t('subscription.templateColumns.annual'),
                            Scheduled:t('subscription.templateColumns.scheduled')
                        }[row.frequency]
                    }
                </span>
            ),
        },
        {
            name: t('subscription.templateColumns.amount'),
            selector: "amount",
            sortable: false,
            format: (row) =>
                getSymbolFromCurrency(userSetting.isoCurrency) +
                row.amount.toLocaleString(userSetting.cultureCode, {
                    minimumFractionDigits: 2,
                }),
        },
        {
            name: t('subscription.templateColumns.status'),
            selector: "active",
            cell: (row) =>
                <span><Tag color={row.status == "Activa" ? "green" : row.status == "Cancelada" ? "red" : "orange"}>{t(`subscription.templateColumns.${row.status}`)} {row.linkToReplaceCard ?" - t('subscription.templateColumns.replacementProcess')" :""}</Tag></span>,
        },
    ];
}